import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { Table, TableFilterEvent, TableModule } from "primeng/table";
import { ActivatedRoute } from "@angular/router";
import * as FileSaver from "file-saver";
import { CommonModule, DatePipe } from "@angular/common";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { ReportsService } from "../../../../core/services/reports.service";
import { MsalApiService } from "../../../../core/services/msal-api.service";
import { OrderSummaryService } from "../../../../core/services/order-summary.service";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { CreateCustOpenInvoiceNoteRequestDto } from "../../../../core/models/reports/createCustOpenInvoiceNoteRequestDto";
import { CustomerAgingDetailReport } from "../../../../core/models/reports/customerAgingDetailReport";
import { GetLoginUserCollecterDetailsForEmailsRequestDto } from "../../../../core/models/reports/getLoginUserCollecterDetailsForEmailsRequestDto";
import { GetLoginUserCollecterDetailsForEmailsResponseDto } from "../../../../core/models/reports/getLoginUserCollecterDetailsForEmailsResponseDto";
import { GetProjectInvoiceReportRequestDto } from "../../../../core/models/orders/getProjectInvoiceReportRequestDto";
import { ArAgingDetailsNoteComponent } from "../ar-aging-details-note/ar-aging-details-note.component";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { LoaderService } from "../../../../core/services/loader.service";
import * as MicrosoftGraph from "@microsoft/microsoft-graph-types";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { CheckboxModule } from "primeng/checkbox";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { OrderSummaryComponent } from "../../../orders/components/order-summary/order-summary.component";
import { ClientDetailsComponent } from "../../../clients/components/client-details/client-details.component";
import { PdfViewerPageComponent } from "../../../../shared/components/pdf-viewer-page/pdf-viewer-page.component";

@Component({
  selector: "jni-ar-aging-details-report",
  templateUrl: "./ar-aging-details-report.component.html",
  styleUrls: ["./ar-aging-details-report.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    ArAgingDetailsNoteComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    CheckboxModule,
    ModalStackerComponent,
    OrderSummaryComponent,
    ClientDetailsComponent,
  ],
  providers: [DatePipe],
})
export class ArAgingDetailsReportComponent implements OnInit {
  constructor(
    private _loaderService: LoaderService,
    private _reportsService: ReportsService,
    private _toastr: JniToastrService,
    private renderer: Renderer2,
    private _orderSummary: OrderSummaryService,
    private _userManagementService: UserManagementService,
    private _profileFormService: ProfileFormService,
    private _msalApisService: MsalApiService,
    private _router: ActivatedRoute,
    public datepipe: DatePipe
  ) {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    this._router.params.subscribe((params: any) => {
      if (!this.customerId) {
        this.customerId = params.CustomerId;
        this.selectedRadioButton = params.selectionRadioType
          ? params.selectionRadioType
          : this.selectedRadioButton;
      }
    });
    /* eslint-enable @typescript-eslint/no-explicit-any */
  }
  selectedRadioButton = "All";
  customerAgingDetailReportListsSelection: CustomerAgingDetailReport[] = [];
  displaySidebarForNotes = false;
  saleOrderId = "";
  orderDisplayModal = false;
  clientDisplayModal = false;
  customerId = "";
  customerAgingDetailReportLists: CustomerAgingDetailReport[] = [];
  filteredDatacustomerAgingDetailReportLists: CustomerAgingDetailReport[] = [];
  filterCustomerAgingDetailReportLists: CustomerAgingDetailReport[] = [];
  selectedRecIdList: string[] = [];
  notesForSidebar = "";
  loginUserCollectorId = 0;
  totalOutstanding = 0;
  descriptionCharacterCond = false;
  @ViewChild("dt") table!: Table;
  @Output() closeEvent = new EventEmitter();
  @Input() fromDashboard = false;

  ngOnInit(): void {
    this.getUserProfile();
    this.getCustomerAgingDetailReport();
  }

  redirectToIp(invoice: string, saleOrderId: string) {
    this.saleOrderId = saleOrderId;
  }

  redirectToSaleorder(saleorder: string) {
    if (saleorder) {
      this.saleOrderId = saleorder;
      this.orderDisplayModal = true;
    }
  }

  onCloseModal() {
    this.closeEvent.emit();
  }

  getMainFiltersOnChange(obj: MouseEvent) {
    const data = obj.target as HTMLInputElement;
    this.table.first = 1;
    if (data?.id == "0") {
      this.filterCustomerAgingDetailReportLists =
        this.customerAgingDetailReportLists.filter(
          x => x.daysPastDate > 0 && x.daysPastDate <= 30
        );
    } else if (data?.id == "30") {
      this.filterCustomerAgingDetailReportLists =
        this.customerAgingDetailReportLists.filter(
          x => x.daysPastDate > 30 && x.daysPastDate <= 60
        );
    } else if (data?.id == "60") {
      this.filterCustomerAgingDetailReportLists =
        this.customerAgingDetailReportLists.filter(
          x => x.daysPastDate > 60 && x.daysPastDate <= 90
        );
    } else if (data?.id == "90") {
      this.filterCustomerAgingDetailReportLists =
        this.customerAgingDetailReportLists.filter(
          x => x.daysPastDate > 90 && x.daysPastDate <= 120
        );
    } else if (data?.id == "120") {
      this.filterCustomerAgingDetailReportLists =
        this.customerAgingDetailReportLists.filter(x => x.daysPastDate > 120);
    } else if (data?.id == "Current") {
      this.filterCustomerAgingDetailReportLists =
        this.customerAgingDetailReportLists.filter(x => x.daysPastDate >= 0);
    } else if (data?.id == "All") {
      this.filterCustomerAgingDetailReportLists =
        this.customerAgingDetailReportLists;
    }
  }

  openSideBarForOrderNotes() {
    if (this.customerAgingDetailReportListsSelection?.length > 1) {
      this.displaySidebarForNotes = true;
      this.notesForSidebar = "";
      this.selectedRecIdList = [];
      this.selectedRecIdList = this.customerAgingDetailReportListsSelection.map(
        x => x.recIdD365.toString()
      );
    }
  }

  closeSideBarForOrderNotes() {
    this.displaySidebarForNotes = false;
  }

  saveNotes(request: CreateCustOpenInvoiceNoteRequestDto) {
    if (request) {
      this._loaderService.setLoaderState(true);
      this._reportsService.createCustOpenInvoiceNote(request).subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            if (res.status?.toLowerCase() == "success") {
              this._toastr.success(res.message, "Success");
              this.closeSideBarForOrderNotes();
              this.getLoginUserCollecterDetailsForEmails(request.Notes);
            } else {
              this._toastr.error(res.message, "Error");
            }
            this.getCustomerAgingDetailReport();
          } else {
            this._toastr.error(res.message, "Error");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(res.message, "Error");
        },
      });
    }
  }

  onlyUnique(value: string, index: number, array: string[]) {
    return array.indexOf(value) === index;
  }

  getLoginUserCollecterDetailsForEmails(notes: string) {
    this._loaderService.setLoaderState(true);
    const invoiceList = this.customerAgingDetailReportListsSelection.map(
      x => x.invoice
    );
    const selectedClientNameList =
      this.customerAgingDetailReportListsSelection.map(x => x.clientD365);

    const uniqueClientNameList = selectedClientNameList.filter(this.onlyUnique);

    const obj: GetLoginUserCollecterDetailsForEmailsRequestDto = {
      invoiceList: invoiceList,
      collectorId: this.loginUserCollectorId,
      clientNameList: uniqueClientNameList.join("; "),
      notes: notes,
    };

    this._reportsService.getLoginUserCollecterDetailsForEmails(obj).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          if (res.status?.toLowerCase() == "success") {
            this.sendCollectorEmail(res.data);
          } else {
            this._toastr.error(res.message, "Error");
          }
          this.getCustomerAgingDetailReport();
        } else {
          this._toastr.error(res.message, "Error");
        }
      },
      error: res => {
        this._loaderService.setLoaderState(false);
        this._toastr.error(res.message, "Error");
      },
    });
  }

  sendCollectorEmail(
    details: GetLoginUserCollecterDetailsForEmailsResponseDto
  ) {
    const toRecipients: MicrosoftGraph.Recipient[] = [
      {
        emailAddress: {
          address: details.collectorEmail,
          name: details.collectorEmail,
        },
      },
    ];

    const sender: MicrosoftGraph.Recipient = {
      emailAddress: {
        address: details.loggedInAdEmail,
        name: details.loggedInAdEmail,
      },
    };

    let mailMessage: MicrosoftGraph.Message = {};

    mailMessage = {
      subject: details.subject,
      body: {
        contentType: "html",
        content: details.html,
      },
      toRecipients: toRecipients,
      sender: sender,
    };

    const mail = {
      message: mailMessage,
    };
    this._msalApisService.sendMail(mail).subscribe({
      next: () => {
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  showInputFieldForLineNote(recIdD365: number, notes: string) {
    if (this.customerAgingDetailReportListsSelection?.length === 1) {
      this.selectedRecIdList = [];
      this.selectedRecIdList.push(recIdD365.toString());
      this.notesForSidebar = notes;
      this.displaySidebarForNotes = true;
    }
  }

  cancelAllEditRow() {
    this.table.value.forEach(x => {
      this.table.cancelRowEdit(x);
    });
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  addScollHiddenClass() {
    this.renderer.addClass(document.body, "p-overflow-hidden");
  }

  getCustomerAgingDetailReport() {
    this._loaderService.setLoaderState(true);
    this._reportsService.getCustomerAgingDetailReport().subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.customerAgingDetailReportLists = res.data;
          this.filteredDatacustomerAgingDetailReportLists =
            this.customerAgingDetailReportLists;
          if (
            this.customerId &&
            this.selectedRadioButton !== "All" &&
            this.selectedRadioButton !== "Current"
          ) {
            this.setInitialLoadOfData();
          }

          if (this.customerId && this.selectedRadioButton === "All") {
            this.customerAgingDetailReportLists =
              this.customerAgingDetailReportLists.filter(
                x => x.customerAccount === this.customerId
              );
          }

          this.customerAgingDetailReportLists =
            this.customerAgingDetailReportLists.sort((a, b) =>
              a.daysPastDate > b.daysPastDate ? -1 : 1
            );
          this.filterCustomerAgingDetailReportLists =
            this.customerAgingDetailReportLists;

          this.calculateSumOfOutstanding();
        } else {
          this._toastr.error(res.message, "Error");
        }
      },
      error: res => {
        this._loaderService.setLoaderState(false);
        this._toastr.error(res.message, "Error");
      },
    });
  }
  setInitialLoadOfData() {
    if (this.selectedRadioButton == "30") {
      this.customerAgingDetailReportLists =
        this.customerAgingDetailReportLists.filter(
          x =>
            x.daysPastDate > 30 &&
            x.daysPastDate <= 60 &&
            x.customerAccount === this.customerId
        );
    } else if (this.selectedRadioButton == "60") {
      this.customerAgingDetailReportLists =
        this.customerAgingDetailReportLists.filter(
          x =>
            x.daysPastDate > 60 &&
            x.daysPastDate <= 90 &&
            x.customerAccount === this.customerId
        );
    } else if (this.selectedRadioButton == "90") {
      this.customerAgingDetailReportLists =
        this.customerAgingDetailReportLists.filter(
          x =>
            x.daysPastDate > 90 &&
            x.daysPastDate <= 120 &&
            x.customerAccount === this.customerId
        );
    } else if (this.selectedRadioButton == "120") {
      this.customerAgingDetailReportLists =
        this.customerAgingDetailReportLists.filter(
          x => x.daysPastDate > 120 && x.customerAccount === this.customerId
        );
    }
  }

  getProjectInvoiceReport(invoiceNumber: string, invoiceDate: string) {
    this._loaderService.setLoaderState(true);
    const reportObject = {
      InvoiceDate: invoiceDate,
      ProjectInvoiceId: invoiceNumber,
    } as GetProjectInvoiceReportRequestDto;
    this._orderSummary.getProjectInvoiceReport(reportObject).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res?.data?.reportBase64String) {
          PdfViewerPageComponent.openInNewTab(
            res.data.reportBase64String,
            `Invoice-${invoiceNumber}`
          );
          // const blob = this.b64toBlob(
          //   res.data.reportBase64String,
          //   "application/pdf"
          // );
          // const blobUrl = URL.createObjectURL(blob);
          // window.open(blobUrl);
        } else {
          this._toastr.error("Error", res.message);
          return;
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Failed To Load PDF");
      },
    });
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  redirectToClientSummary(customerId: string) {
    if (customerId) {
      this.customerId = customerId;
      this.clientDisplayModal = true;
    }
  }

  closeClientModal() {
    this.clientDisplayModal = false;
  }

  getUserProfile() {
    this._userManagementService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res?.data != null) {
          this.loginUserCollectorId = res?.data?.collectorId ?? 0;
        }
      },
    });
  }

  calculateSumOfOutstanding() {
    if (this.customerAgingDetailReportLists.length > 0) {
      this.totalOutstanding = this.customerAgingDetailReportLists.reduce(
        (total, charge) => total + charge.openAmountUSD,
        0
      );
    }
  }

  descriptionCharacterCount(obj: string) {
    if (obj && obj.length > 45) this.descriptionCharacterCond = true;
  }

  // rowSelected() {
  //   if (this.customerAgingDetailReportListsSelection.length >= 6) {
  //     const lastItem = this.customerAgingDetailReportListsSelection.pop();
  //   }
  // }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }

  exportExcelForFilterData() {
    const object = this.filteredDatacustomerAgingDetailReportLists.map(
      datum => {
        return {
          ["Invoice"]: datum.invoice,
          ["Sales Order"]: datum.salesOrder,
          ["Client Name"]: datum.clientD365,
          ["Client PO #"]: datum.customerPONumber,
          ["Job Name"]: datum.projectName,
          ["Due Date"]: this.datepipe.transform(datum.dueDate, "MM-dd-YYYY"),
          ["Orig Inv Amt"]: datum.invoiceAmount,
          ["Cur"]: datum.currency,
          ["Terms"]: datum.paymTermId,
          ["Outstanding $"]: datum.openAmountUSD,
          ["Days Past Due"]: datum.daysPastDate,
          ["AR Notes"]: datum.note,
        };
      }
    );

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "ARAgingDashboardReport");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  onFilter(event: TableFilterEvent) {
    if (event?.filters && event?.filteredValue?.length > 0) {
      this.filteredDatacustomerAgingDetailReportLists = event.filteredValue;
    } else {
      this.filteredDatacustomerAgingDetailReportLists =
        this.filterCustomerAgingDetailReportLists;
    }

    // As per the ticket 12162 totals will show on filters
    this.totalOutstanding =
      this.filteredDatacustomerAgingDetailReportLists.reduce(
        (total, charge) => total + charge.openAmountUSD,
        0
      );
  }
}
